import { brPt, gradeColorTexto } from "../../lib/format";
import { cn } from "../../lib/utils";
import { HoverPopover } from "../ui/HoverPopover";

const TIPOS_NOTA = [
  ["nota_rede", "Avaliação em Rede"],
  ["nota_avaliacao", "Avaliação"],
  ["nota_regular", "Regular"]
];

/** Célula de nota com tooltip do detalhamento por tipo de atividade (Avaliação
 * em Rede/Avaliação/Regular) — usada em qualquer ranking (turma, escola,
 * região) que exponha os mesmos campos de NotaTipos. */
export function NotaCell({ dados }) {
  return (
    <HoverPopover
      width={208}
      trigger={
        <span
          className="tnum font-bold"
          style={{ color: gradeColorTexto(dados.nota) }}
        >
          {brPt(dados.nota)}
        </span>
      }
    >
      <span className="block border-b border-[var(--color-brand)]/20 bg-[var(--color-brand-dim)] px-3 py-2 text-[10px] font-semibold uppercase tracking-wide text-[var(--color-brand-dark)]">
        Nota por tipo de atividade
      </span>
      <span className="block p-3">
        {TIPOS_NOTA.map(([k, lbl]) => {
          const v = dados[k];
          const ativo =
            dados.nota_tipo ===
            (k === "nota_rede"
              ? "rede"
              : k === "nota_avaliacao"
              ? "avaliacao"
              : "regular");
          return (
            <span
              key={k}
              className="flex items-center justify-between py-0.5 text-[12px]"
            >
              <span
                className={cn(
                  "flex items-center gap-1.5",
                  ativo
                    ? "text-[var(--color-ink)]"
                    : "text-[var(--color-ink-soft)]"
                )}
              >
                <span
                  style={{
                    color: ativo
                      ? "var(--color-brand)"
                      : "var(--color-ink-faint)"
                  }}
                >
                  {ativo ? "●" : "○"}
                </span>
                {lbl}
              </span>
              <span className="tnum font-medium">
                {v == null ? "–" : brPt(v)}
              </span>
            </span>
          );
        })}
      </span>
    </HoverPopover>
  );
}
